// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ShuffleChildren$LiteracyplanetTupperware from "../ShuffleChildren.res.mjs";
import * as V3CustomTableContext$LiteracyplanetTupperware from "./V3CustomTableContext.res.mjs";
import * as V3MultliChoiceStyleContext$LiteracyplanetTupperware from "./V3MultliChoiceStyleContext.res.mjs";

function V3CustomTable$MultiResponseMultiChoiceContainer(props) {
  return React.createElement("div", {
              className: "pilot-multi-response-sets-table"
            }, React.createElement(V3MultliChoiceStyleContext$LiteracyplanetTupperware.Provider.make, {
                  value: "MultiChoiceRadioSets",
                  children: React.createElement(ShuffleChildren$LiteracyplanetTupperware.make, {
                        children: props.children
                      })
                }));
}

var MultiResponseMultiChoiceContainer = {
  make: V3CustomTable$MultiResponseMultiChoiceContainer
};

function V3CustomTable$HighlightAnswerSets(props) {
  return React.createElement("div", {
              className: "MultiResHighlightSentenceponseMultiChoiceContainer"
            }, React.createElement(V3MultliChoiceStyleContext$LiteracyplanetTupperware.Provider.make, {
                  value: {
                    TAG: "MultiChoiceHighlightSets",
                    marking: props.marking
                  },
                  children: React.createElement("div", {
                        className: "highlightAnswerSets"
                      }, React.createElement(ShuffleChildren$LiteracyplanetTupperware.make, {
                            children: props.children
                          }))
                }));
}

var HighlightAnswerSets = {
  make: V3CustomTable$HighlightAnswerSets
};

function V3CustomTable$GridMatchLeftToRight(props) {
  return React.createElement("table", {
              className: "gridMatchLeftToRight"
            }, props.children);
}

var GridMatchLeftToRight = {
  make: V3CustomTable$GridMatchLeftToRight
};

function V3CustomTable$GridMatchRightToLeft(props) {
  return React.createElement("div", {
              className: "gridMatchRightToLeft"
            }, props.children);
}

var GridMatchRightToLeft = {
  make: V3CustomTable$GridMatchRightToLeft
};

function V3CustomTable$InstructionAndHint(props) {
  return React.createElement("div", {
              className: "InstructionAndHint"
            }, props.children);
}

var InstructionAndHint = {
  make: V3CustomTable$InstructionAndHint
};

function V3CustomTable(props) {
  var children = props.children;
  var context = props.context;
  var match = context.kind;
  var tmp;
  if (typeof match !== "object") {
    switch (match) {
      case "GridMatchLeftToRight" :
          tmp = React.createElement(V3CustomTable$GridMatchLeftToRight, {
                children: children
              });
          break;
      case "GridMatchRightToLeft" :
          tmp = React.createElement(V3CustomTable$GridMatchRightToLeft, {
                children: children
              });
          break;
      case "InstructionAndHint" :
          tmp = React.createElement(V3CustomTable$InstructionAndHint, {
                children: children
              });
          break;
      
    }
  } else {
    tmp = match.TAG === "HighlightResponseSets" ? React.createElement(V3CustomTable$HighlightAnswerSets, {
            marking: match.marking,
            children: children
          }) : React.createElement(V3CustomTable$MultiResponseMultiChoiceContainer, {
            children: children
          });
  }
  return React.createElement(V3CustomTableContext$LiteracyplanetTupperware.Provider.make, {
              value: context,
              children: tmp
            });
}

var make = V3CustomTable;

var $$default = V3CustomTable;

export {
  MultiResponseMultiChoiceContainer ,
  HighlightAnswerSets ,
  GridMatchLeftToRight ,
  GridMatchRightToLeft ,
  InstructionAndHint ,
  make ,
  $$default as default,
}
/* react Not a pure module */
